// The ONE Launch commit policy, shared by the server (enforced in
// src/server/capabilities/launch/create/access.ts) and the browser (which only
// shapes what it shows — a viewer gets no Launch route or navigation entry, and
// anyone below member sees a read-only explanation instead of silently
// disabled controls). Keep it named so a future role cannot turn a transport or
// UI check into an accidental publishing grant.
import type { Role } from "@aco/core";

export interface LaunchViewer {
  isSuperAdmin: boolean;
  organizations: ReadonlyArray<{ slug: string; role: Role }>;
}

export function hasLaunchCommitRole(role: string): boolean {
  // Admin and member commit; viewer and any unknown future role fail closed.
  return role === "admin" || role === "member";
}

export function canCommitLaunch(viewer: LaunchViewer, orgSlug: string): boolean {
  if (viewer.isSuperAdmin) return true;
  const organization = viewer.organizations.find((org) => org.slug === orgSlug);
  return organization ? hasLaunchCommitRole(organization.role) : false;
}

// Where a Launch route sends someone who may not use Launch. Media Performance
// is the only module every workspace role can open, so a viewer lands there
// (the same destination the workspace switcher uses).
export function launchRouteRedirect(
  viewer: LaunchViewer,
  orgSlug: string,
): { to: "/$orgSlug/media-performance"; params: { orgSlug: string } } | null {
  if (canCommitLaunch(viewer, orgSlug)) return null;
  return { to: "/$orgSlug/media-performance", params: { orgSlug } };
}
